import script from "./loginPartial.vue?vue&type=script&setup=true&lang=ts"
export * from "./loginPartial.vue?vue&type=script&setup=true&lang=ts"

import "./loginPartial.vue?vue&type=style&index=0&id=72962430&lang=scss&scoped=true"

import exportComponent from "/builds/psj7085139/sam/samva-ui/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-72962430"]])

export default __exports__